// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falChartPieSimple: CreateIconOptions = {
  "displayName": "FALChartPieSimple",
  "viewBox": "0, 0, 512, 512",
  "d": "M256 17.7l0 9.4L256 240c0 8.8 7.2 16 16 16l222.3 0c9.6 0 17.7-7.4 17.7-17.1C512 107 405 0 273.1 0C263.4 0 256 8.1 256 17.7zm32 14.8C390.4 39.8 472.2 121.6 479.5 224L288 224l0-191.5zM192 288c0 17.7 14.3 32 32 32l218.4 0C420.8 411.7 338.3 480 240 480C125.1 480 32 386.9 32 272c0-98.3 68.3-180.8 160-202.4L192 288zM224 66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.6 107.5 512 240 512c115.5 0 211.9-81.5 234.8-190.2c3.8-18.1-11-33.8-29.5-33.8L256 288l-32 0 0-32 0-189.3z"
};
